import React from 'react';
import { Container, ColumnContainer, Title, Value } from './styles';
export var SingleCard = function (_a) {
    var values = _a.values, width = _a.width, height = _a.height;
    return (React.createElement(Container, { width: width, height: height }, values.map(function (el, index) { return (React.createElement(ColumnContainer, { key: el.title + " - " + index },
        React.createElement(Title, null, el.title),
        React.createElement(ColumnContainer, null, el.values.map(function (value) { return (React.createElement(Value, { key: value + " - " + index }, value)); })))); })));
};
